/* The number of options to move the selection by when pressing page up/down. */
const pageSize = 7;
/**
 * Translates keyboard events into semantic selection actions.
 */
function getActionFromKeyboardEvent(event, open) {
  const {
    key,
    altKey
  } = event;
  if (open) {
    switch (key) {
      case 'Escape':
        return 'close';
      case 'Enter':
        return 'select';
      case 'ArrowUp':
        return altKey ? 'select' : 'previous';
      case 'ArrowDown':
        return altKey ? 'select' : 'next';
      case 'ArrowLeft':
        return 'collapse';
      case 'ArrowRight':
        return 'expand';
      case 'PageUp':
        return 'pageup';
      case 'PageDown':
        return 'pagedown';
      default:
        return null;
    }
  } else {
    switch (key) {
      case 'Enter':
      case 'ArrowUp':
      case 'ArrowDown':
      case 'PageUp':
      case 'PageDown':
        return 'open';
      default:
        return null;
    }
  }
}

/**
 * Given a set of options, an active value, and a keyboard navigation action,
 * determine the value of the next selected option.
 *
 * When no value is active, the operation is performed relative to the index
 * preceding all options.
 *
 * Optionally this may take in a set of extra values which are considered to be
 * special option values that precede the normal select options.
 */
function navigateOptions(params) {
  const {
    action,
    options,
    extraValues,
    activeValue
  } = params;
  switch (action) {
    case 'previous':
      return navigateOptionsByAmount({
        options,
        extraValues,
        activeValue,
        dIndex: -1,
        wrap: true
      });
    case 'next':
      return navigateOptionsByAmount({
        options,
        extraValues,
        activeValue,
        dIndex: 1,
        wrap: true
      });
    case 'pageup':
      return navigateOptionsByAmount({
        options,
        extraValues,
        activeValue,
        dIndex: -7,
        wrap: false
      });
    case 'pagedown':
      return navigateOptionsByAmount({
        options,
        extraValues,
        activeValue,
        dIndex: pageSize,
        wrap: false
      });
  }
}
function navigateOptionsByAmount(params) {
  const {
    options,
    extraValues = [],
    activeValue,
    dIndex,
    wrap
  } = params;
  const focusableOptions = options.filter(option => !option.disabled);
  const minIndex = -extraValues.length;
  const maxIndex = focusableOptions.length - 1;
  let index = extraValues.indexOf(activeValue);
  if (index != -1) {
    index = minIndex + index;
  } else {
    index = focusableOptions.findIndex(option => option.value === activeValue);
    if (index === -1) {
      index = minIndex - 1;
    }
  }
  index += dIndex;
  if (index < minIndex) {
    if (wrap) {
      index = maxIndex;
    } else {
      index = minIndex;
    }
  } else if (index > maxIndex) {
    if (wrap) {
      index = minIndex;
    } else {
      index = maxIndex;
    }
  }
  if (index < 0) {
    return extraValues[index - minIndex];
  } else {
    const option = focusableOptions[index];
    return option.value;
  }
}

export { getActionFromKeyboardEvent, navigateOptions };
